const defaults = Object.freeze({
	employee: { singular: 'employee', plural: 'employees' },
	companyPolicy: { singular: 'company policy', plural: 'company policies' },
	positionTemplate: { singular: 'position template', plural: 'position templates' },
	positionDescription: { singular: 'position description', plural: 'position descriptions' }
});

export function resolveTerminology(terminology) {
	const source = terminology || {};
	const resolved = {};

	Object.keys(defaults).forEach(key => {
		const configured = source[key] || {};
		resolved[key] = {
			singular: clean(configured.singular) || defaults[key].singular,
			plural: clean(configured.plural) || defaults[key].plural
		};
	});

	return resolved;
}

export function formatTerm(terminology, key, options = {}) {
	const term = resolveTerminology(terminology)[key];
	if (!term) return key;

	const plural = typeof options.count === 'number' ? options.count !== 1 : !!options.plural;
	let value = plural ? term.plural : term.singular;

	if (options.abbreviation || options.abbreviate) {
		value = value.split(/\s+/).map(word => word.charAt(0)).join('');
		if (!options.case) value = value.toUpperCase();
	}
	switch (options.case) {
		case 'sentence': value = sentenceCase(value); break;
		case 'title': value = value.split(/\s+/).map(sentenceCase).join(' '); break;
		case 'upper': value = value.toUpperCase(); break;
		case 'lower': value = value.toLowerCase(); break;
	}

	if (options.possessive) value = /s$/i.test(value) ? `${value}'` : `${value}'s`;
	if (options.article) value = `${indefiniteArticle(value)} ${value}`;

	return value;
}

export function termSlug(terminology, key, options = {}) {
	return formatTerm(terminology, key, options)
		.toLowerCase()
		.replace(/[^a-z0-9]+/g, '-')
		.replace(/^-|-$/g, '');
}

function clean(value) {
	return typeof value === 'string' && value.trim() ? value.trim() : null;
}

function sentenceCase(value) {
	return value ? value.charAt(0).toUpperCase() + value.slice(1) : value;
}

function indefiniteArticle(value) {
	return /^[aeiou]/i.test(value || '') ? 'an' : 'a';
}
